import { createStore } from 'vuex'
import getters from './getters'
import user from './modules/user'
import permission from './modules/permission.js'
import building from './modules/building.js'
import app from './modules/app.js'

export default createStore({
    getters,
    modules: {
        user,
        permission,
        building,
        app
    }
})
